import React from 'react';

const BundleCard = ({ 	main_genre, tags, values, animationDelay }) => {

  // Parse and render HTML safely
  const createMarkup = (html) => {
    return { __html: html };
  };
  const mainGenreFormatted = main_genre && Object.values(main_genre)[0];

  return (
    <li className="featured__item react" style={animationDelay}>
      <div className="featured__item_link">
        <section className="grid-item promo-section">
          <div className="promo">
            <article className={"promo__item" + ' ' + values.color}>
              <div className="promo__item-img-container">
                <img className="promo__item-img" src={values.image} alt=""></img>
              </div>
              <div className="promo__item-content flow">

                <h2 className="promo__item-title h4">{values.title}</h2>
                <div className="promo__item-text" dangerouslySetInnerHTML={createMarkup(values.text)}></div>
					 <ul className="label-list">
												{mainGenreFormatted && mainGenreFormatted.trim() !== '' && mainGenreFormatted !== 'Leeg' && (
													<li className="agenda-item__tag" key="extra-item">
														<span className="label-item">{mainGenreFormatted}</span>
													</li>
												)}
												{tags &&
													Object.keys(tags).map((tag, index) => {
														return (
															<li className="agenda-item__tag" key={index} data-value={tags[tag]}>
																<span className="label-item">{parseEntities(tags[tag])}</span>
															</li>
														);
													})}
											</ul>
                <div className="card__button-container">
                  <a className="btn" href={values.link}>{values.linktxt}</a>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </li>
  );
};

export default BundleCard;
